import { IconWeight } from '@nimbus-library/features/shared/directives/icon-weight.enum';

export interface Icon {
  icon: string;
  weight: IconWeight;
}

export const ICONS = {
  ADD: { icon: 'nimbus-plus', weight: IconWeight.Regular },
  ADDON_SOLID: { icon: 'nimbus-addon', weight: IconWeight.Bold },
  ADDRESS_BOOK: { icon: 'nimbus-address-book', weight: IconWeight.Regular },
  ADDRESS_BOOK_LIGHT: { icon: 'nimbus-address-book', weight: IconWeight.Light },
  ADD_CIRCLE: { icon: 'nimbus-add-circle', weight: IconWeight.Regular },
  ADD_LIGHT: { icon: 'nimbus-plus', weight: IconWeight.Light },
  ADD_LINES_LIGHT: { icon: 'nimbus-plus-entity', weight: IconWeight.Light },
  AI: { icon: 'nimbus-ai', weight: IconWeight.Regular },
  ALIGN_CENTER: { icon: 'nimbus-align-center', weight: IconWeight.Regular },
  ALIGN_LEFT: { icon: 'nimbus-align-left', weight: IconWeight.Regular },
  ALIGN_RIGHT: { icon: 'nimbus-align-right', weight: IconWeight.Regular },
  ANGLE_DOUBLE_LEFT: { icon: 'nimbus-angle-double-left', weight: IconWeight.Regular },
  ANGLE_DOUBLE_RIGHT: { icon: 'nimbus-angle-double-right', weight: IconWeight.Regular },
  ANGLE_DOWN: { icon: 'nimbus-angle-down', weight: IconWeight.Regular },
  ANGLE_DOWN_LIGHT: { icon: 'nimbus-angle-down', weight: IconWeight.Light },
  ANGLE_UP: { icon: 'nimbus-angle-up', weight: IconWeight.Regular },
  ANGLE_UP_LIGHT: { icon: 'nimbus-angle-up', weight: IconWeight.Light },
  ANONYM: { icon: 'nimbus-anonym', weight: IconWeight.Regular },
  ANONYM_LIGHT: { icon: 'nimbus-anonym', weight: IconWeight.Light },
  ARROW_DOWN: { icon: 'nimbus-arrow-down', weight: IconWeight.Regular },
  ARROW_LEFT: { icon: 'nimbus-arrow-left', weight: IconWeight.Regular },
  ARROW_LEFT_LIGHT: { icon: 'nimbus-arrow-left', weight: IconWeight.Light },
  ARROW_LEFT_NEW: { icon: 'nimbus-arrow-left', weight: IconWeight.Regular },
  ARROW_RIGHT: { icon: 'nimbus-arrow-right', weight: IconWeight.Regular },
  ARROW_RIGHT_NEW: { icon: 'nimbus-arrow-right', weight: IconWeight.Regular },
  ARROW_UP_DOWN: { icon: 'nimbus-arrow-up-down', weight: IconWeight.Regular },
  ASSISTANCE: { icon: 'nimbus-assistant', weight: IconWeight.Regular },
  ATTACHMENT: { icon: 'nimbus-attachment', weight: IconWeight.Regular },
  ATTACHMENT_LIGHT: { icon: 'nimbus-attachment', weight: IconWeight.Light },
  ATTENDANT_CONSOLE: { icon: 'nimbus-attendant-console', weight: IconWeight.Regular },
  AVAILABILITY_BASED_ROUTING: { icon: 'nimbus-check-circle', weight: IconWeight.Regular },
  BAN: { icon: 'nimbus-ban', weight: IconWeight.Regular },
  BELL: { icon: 'nimbus-bell', weight: IconWeight.Regular },
  BELL_SLASH: { icon: 'nimbus-bell-slash', weight: IconWeight.Regular },
  BOLD: { icon: 'nimbus-bold', weight: IconWeight.Regular },
  BOLT: { icon: 'nimbus-bolt', weight: IconWeight.Light },
  BOLT_SOLID: { icon: 'nimbus-bolt', weight: IconWeight.Regular },
  BRAND: { icon: 'nimbus-luware-shell', weight: IconWeight.Regular },
  BRUSH: { icon: 'nimbus-brush', weight: IconWeight.Regular },
  BRUSH_LIGHT: { icon: 'nimbus-brush', weight: IconWeight.Light },
  BULLETS: { icon: 'nimbus-bullets', weight: IconWeight.Regular },
  BUSINESS: { icon: 'nimbus-business', weight: IconWeight.Light },
  CALENDAR: { icon: 'nimbus-calendar', weight: IconWeight.Regular },
  CALENDAR_LIGHT: { icon: 'nimbus-calendar', weight: IconWeight.Light },
  CALLBACK: { icon: 'nimbus-callback', weight: IconWeight.Regular },
  CALL_BUSINESS: { icon: 'nimbus-business', weight: IconWeight.Light },
  CALL_FLOW: { icon: 'nimbus-call-flow', weight: IconWeight.Regular },
  CALL_OK: { icon: 'nimbus-phone', weight: IconWeight.Regular },
  CALL_TEAMS: { icon: 'nimbus-teams', weight: IconWeight.Light },
  CALL_TEAMS_REGULAR: { icon: 'nimbus-teams', weight: IconWeight.Regular },
  CANCEL_TASK: { icon: 'nimbus-cancel-task', weight: IconWeight.Regular },
  CHANGE_HISTORY: { icon: 'nimbus-historical-sessions', weight: IconWeight.Light },
  CHECK: { icon: 'nimbus-check', weight: IconWeight.Regular },
  CHECK_AVAILABLE_USERS: { icon: 'nimbus-check-available-users', weight: IconWeight.Regular },
  CHECK_CIRCLE: { icon: 'nimbus-check-circle', weight: IconWeight.Regular },
  CHECK_CIRCLE_LIGHT: { icon: 'nimbus-check-circle', weight: IconWeight.Light },
  CHECK_LIGHT: { icon: 'nimbus-check', weight: IconWeight.Light },
  CHECK_PARAMETERS: { icon: 'nimbus-check-parameters', weight: IconWeight.Regular },
  CHECK_QUEUE_POSITION: { icon: 'nimbus-check-queue-position', weight: IconWeight.Regular },
  CHECK_TASK: { icon: 'nimbus-check-task', weight: IconWeight.Regular },
  CHEVRON_DOWN: { icon: 'nimbus-chevron-down', weight: IconWeight.Regular },
  CHEVRON_DOWN_LIGHT: { icon: 'nimbus-chevron-down', weight: IconWeight.Light },
  CHEVRON_LEFT: { icon: 'nimbus-chevron-left', weight: IconWeight.Regular },
  CHEVRON_LEFT_LIGHT: { icon: 'nimbus-chevron-left', weight: IconWeight.Light },
  CHEVRON_RIGHT: { icon: 'nimbus-chevron-right', weight: IconWeight.Regular },
  CHEVRON_RIGHT_LIGHT: { icon: 'nimbus-chevron-right', weight: IconWeight.Light },
  CHEVRON_UP: { icon: 'nimbus-chevron-up', weight: IconWeight.Regular },
  CHEVRON_UP_LIGHT: { icon: 'nimbus-chevron-up', weight: IconWeight.Light },
  CIRCLE: { icon: 'nimbus-circle', weight: IconWeight.Regular },
  CIRCLE_BOLT: { icon: 'nimbus-circle-bolt', weight: IconWeight.Light },
  CIRCLE_BOLT_SOLID: { icon: 'nimbus-circle-bolt', weight: IconWeight.Regular },
  CLOCK: { icon: 'nimbus-clock', weight: IconWeight.Regular },
  CLOCK_ADD: { icon: 'nimbus-clock-add', weight: IconWeight.Light },
  CLOCK_LIGHT: { icon: 'nimbus-clock', weight: IconWeight.Light },
  CLOSE: { icon: 'nimbus-times', weight: IconWeight.Regular },
  CLOSE_LIGHT: { icon: 'nimbus-times', weight: IconWeight.Light },
  COG: { icon: 'nimbus-cog', weight: IconWeight.Regular },
  COG_LIGHT: { icon: 'nimbus-cog', weight: IconWeight.Light },
  COLLAPSE: { icon: 'nimbus-collapse', weight: IconWeight.Regular },
  COLLAPSE_ACTIVITIES: { icon: 'nimbus-collapse-activities', weight: IconWeight.Light },
  COLLAPSE_ROW: { icon: 'nimbus-collapse-row', weight: IconWeight.Light },
  COLUMNS: { icon: 'nimbus-columns', weight: IconWeight.Regular },
  COLUMN_RESET: { icon: 'nimbus-column-reset', weight: IconWeight.Regular },
  COMMENT: { icon: 'nimbus-comment', weight: IconWeight.Regular },
  COMMENT_ALT: { icon: 'nimbus-comment-alt', weight: IconWeight.Regular },
  COMMENT_ALT_LIGHT: { icon: 'nimbus-comment-alt', weight: IconWeight.Light },
  COMMENT_CIRCLE: { icon: 'nimbus-comment', weight: IconWeight.Regular },
  COMMENT_CIRCLE_LIGHT: { icon: 'nimbus-comment', weight: IconWeight.Light },
  COMMENT_LIGHT: { icon: 'nimbus-comment', weight: IconWeight.Light },
  COMPANION: { icon: 'nimbus-companion', weight: IconWeight.Regular },
  COMPANION_LIGHT: { icon: 'nimbus-companion', weight: IconWeight.Light },
  COMPANION_TRANSCRIPTION_LIGHT: { icon: 'nimbus-companion-transcription', weight: IconWeight.Light },
  COMPANION_GREETING: { icon: 'nimbus-companion-greeting', weight: IconWeight.Regular },
  COMPILER: { icon: 'nimbus-compiler', weight: IconWeight.Light },
  CONSULTATION_CALL: { icon: 'nimbus-consultation-call', weight: IconWeight.Regular },
  CONVERSATION_CONTEXT: { icon: 'nimbus-comments', weight: IconWeight.Light },
  COPY: { icon: 'nimbus-copy', weight: IconWeight.Light },
  DASHBOARD: { icon: 'nimbus-dashboard', weight: IconWeight.Regular },
  DASHBOARD_LIGHT: { icon: 'nimbus-dashboard', weight: IconWeight.Light },
  DECLINE: { icon: 'nimbus-decline', weight: IconWeight.Regular },
  DECLINE_RETRIEVE: { icon: 'nimbus-decline-retrieve', weight: IconWeight.Regular },
  DECREASE_FONT_SIZE: { icon: 'nimbus-decrease-font-size', weight: IconWeight.Regular },
  DECREASE_INDENT: { icon: 'nimbus-decrease-indent', weight: IconWeight.Regular },
  DELAY: { icon: 'nimbus-delay', weight: IconWeight.Regular },
  DELAY_LIGHT: { icon: 'nimbus-delay', weight: IconWeight.Light },
  DELETE: { icon: 'nimbus-trash-alt', weight: IconWeight.Bold },
  DELETE_NOTE_POPUP: { icon: 'nimbus-trash-alt', weight: IconWeight.Regular },
  DIAL_PAD: { icon: 'nimbus-dial-pad', weight: IconWeight.Regular },
  DISTRIBUTION: { icon: 'nimbus-distribution', weight: IconWeight.Regular },
  DOWNLOAD: { icon: 'nimbus-download', weight: IconWeight.Regular },
  DUPLICATE: { icon: 'nimbus-duplicate', weight: IconWeight.Light },
  EAR: { icon: 'nimbus-ear', weight: IconWeight.Regular },
  EAR_LIGHT: { icon: 'nimbus-ear', weight: IconWeight.Light },
  EDIT: { icon: 'nimbus-pen', weight: IconWeight.Regular },
  EDIT_NOTE: { icon: 'nimbus-comment-alt', weight: IconWeight.Light },
  EDIT_NOTE_POPUP: { icon: 'nimbus-pen', weight: IconWeight.Regular },
  ELLIPSIS_H: { icon: 'nimbus-ellipsis-h', weight: IconWeight.Regular },
  ELLIPSIS_V: { icon: 'nimbus-ellipsis-v', weight: IconWeight.Regular },
  ENVELOPE: { icon: 'nimbus-envelope', weight: IconWeight.Regular },
  ENVELOPE_LIGHT: { icon: 'nimbus-envelope', weight: IconWeight.Light },
  EXCLAMATION: { icon: 'nimbus-exclamation', weight: IconWeight.Regular },
  EXCLAMATION_CIRCLE: { icon: 'nimbus-exclamation-circle', weight: IconWeight.Regular },
  EXCLAMATION_CIRCLE_LIGHT: { icon: 'nimbus-exclamation-circle', weight: IconWeight.Light },
  EXCLAMATION_TRIANGLE: { icon: 'nimbus-exclamation-triangle', weight: IconWeight.Regular },
  EXCLAMATION_TRIANGLE_LIGTH: { icon: 'nimbus-exclamation-triangle', weight: IconWeight.Light },
  EXPAND: { icon: 'nimbus-expand', weight: IconWeight.Regular },
  EXPAND_ACTIVITIES: { icon: 'nimbus-expand-activities', weight: IconWeight.Light },
  EXPAND_ROW: { icon: 'nimbus-expand-row', weight: IconWeight.Light },
  EXTERNAL_LINK: { icon: 'nimbus-external-link', weight: IconWeight.Light },
  EXTERNAL_LINK_SOLID: { icon: 'nimbus-external-link', weight: IconWeight.Regular },
  EXTERNAL_TASK: { icon: 'nimbus-external-task', weight: IconWeight.Bold },
  EXTERNAL_TASK_LIGHT: { icon: 'nimbus-external-task', weight: IconWeight.Light },
  EYE: { icon: 'nimbus-eye', weight: IconWeight.Regular },
  EYE_LIGHT: { icon: 'nimbus-eye', weight: IconWeight.Light },
  EYE_SLASH: { icon: 'nimbus-eye-slash', weight: IconWeight.Regular },
  EYE_SLASH_LIGHT: { icon: 'nimbus-eye-slash', weight: IconWeight.Light },
  FILTER: { icon: 'nimbus-filter', weight: IconWeight.Regular },
  FILTER_LIST: { icon: 'nimbus-filter-list', weight: IconWeight.Regular },
  FIT_TO_100: { icon: 'nimbus-fit-to-100', weight: IconWeight.Light },
  FLASK: { icon: 'nimbus-beta', weight: IconWeight.Regular },
  FLASK_LIGHT: { icon: 'nimbus-beta', weight: IconWeight.Light },
  FOLDER: { icon: 'nimbus-folder', weight: IconWeight.Regular },
  FOLDER_LIGHT: { icon: 'nimbus-folder', weight: IconWeight.Light },
  FORWARD: { icon: 'nimbus-external-link', weight: IconWeight.Regular },
  FORWARD_EMAIL: { icon: 'nimbus-forward', weight: IconWeight.Regular },
  GLOBE: { icon: 'nimbus-globe', weight: IconWeight.Regular },
  GLOBE_LIGHT: { icon: 'nimbus-globe', weight: IconWeight.Light },
  HANDSHAKE: { icon: 'nimbus-partner', weight: IconWeight.Regular },
  HEADSET: { icon: 'nimbus-headset', weight: IconWeight.Light },
  HOLD: { icon: 'nimbus-pause', weight: IconWeight.Regular },
  HOLD_CALL: { icon: 'nimbus-hold-call', weight: IconWeight.Regular },
  HOME: { icon: 'nimbus-home', weight: IconWeight.Regular },
  HOME_LIGHT: { icon: 'nimbus-home', weight: IconWeight.Light },
  HOURGLASS_START: { icon: 'nimbus-hourglass-start', weight: IconWeight.Regular },
  HOURGLASS_START_LIGHT: { icon: 'nimbus-hourglass-start', weight: IconWeight.Light },
  ID_BADGE: { icon: 'nimbus-id-badge', weight: IconWeight.Regular },
  INCREASE_FONT_SIZE: { icon: 'nimbus-increase-font-size', weight: IconWeight.Regular },
  INCREASE_INDENT: { icon: 'nimbus-increase-indent', weight: IconWeight.Regular },
  INFORMATION: { icon: 'nimbus-info-circle', weight: IconWeight.Regular },
  INFORMATION_LIGHT: { icon: 'nimbus-info-circle', weight: IconWeight.Light },
  INFO_CIRCLE: { icon: 'nimbus-info-circle', weight: IconWeight.Regular },
  INFO_CIRCLE_LIGHT: { icon: 'nimbus-info-circle', weight: IconWeight.Light },
  INFO_CIRCLE_NEW: { icon: 'nimbus-info-circle', weight: IconWeight.Regular },
  INTERACT: { icon: 'nimbus-interact', weight: IconWeight.Regular },
  ITALIC: { icon: 'nimbus-italic', weight: IconWeight.Regular },
  JUSTIFY_ALIGNMENT: { icon: 'nimbus-justify-alignment', weight: IconWeight.Regular },
  KPI_BELL: { icon: 'nimbus-bell', weight: IconWeight.Regular },
  KPI_CHECK: { icon: 'nimbus-check', weight: IconWeight.Regular },
  KPI_PLUG: { icon: 'nimbus-plug', weight: IconWeight.Regular },
  LAYER: { icon: 'nimbus-layer-group', weight: IconWeight.Light },
  LAYER_GROUP: { icon: 'nimbus-layer-group', weight: IconWeight.Regular },
  LAYER_GROUP_LIGHT: { icon: 'nimbus-layer-group', weight: IconWeight.Light },
  LETTER: { icon: 'nimbus-letter', weight: IconWeight.Regular },
  LICENSE: { icon: 'nimbus-id-badge', weight: IconWeight.Regular },
  LICENSING_PAGE: { icon: 'nimbus-license', weight: IconWeight.Regular },
  LINK: { icon: 'nimbus-link', weight: IconWeight.Regular },
  LOCK: { icon: 'nimbus-lock', weight: IconWeight.Regular },
  LOCK_LIGHT: { icon: 'nimbus-lock', weight: IconWeight.Light },
  LOGOUT: { icon: 'nimbus-power-off', weight: IconWeight.Regular },
  LOGOUT_POPUP: { icon: 'nimbus-power-off', weight: IconWeight.Regular },
  MAP: { icon: 'nimbus-map', weight: IconWeight.Light },
  MARK_AS_HANDLED: { icon: 'nimbus-mark-as-handled', weight: IconWeight.Regular },
  MENU: { icon: 'nimbus-menu', weight: IconWeight.Light },
  MERGE: { icon: 'nimbus-merge', weight: IconWeight.Regular },
  MICROPHONE: { icon: 'nimbus-microphone', weight: IconWeight.Regular },
  MICROPHONE_SLASH: { icon: 'nimbus-microphone-slash', weight: IconWeight.Regular },
  MONOSPACE: { icon: 'nimbus-monospace', weight: IconWeight.Regular },
  MOUSE_SCROLL: { icon: 'nimbus-mouse-scroll', weight: IconWeight.Regular },
  MS_BOT_FRAMEWORK: { icon: 'nimbus-ms-bot-framework', weight: IconWeight.Light },
  MYSESSIONS: { icon: 'nimbus-comments', weight: IconWeight.Regular },
  MYSESSIONS_LIGHT: { icon: 'nimbus-comments', weight: IconWeight.Light },
  NOTE: { icon: 'nimbus-note', weight: IconWeight.Regular },
  NOTE_LIGHT: { icon: 'nimbus-note', weight: IconWeight.Light },
  NUMBERING: { icon: 'nimbus-numbering', weight: IconWeight.Regular },
  O365: { icon: 'nimbus-o365', weight: IconWeight.Regular },
  OPERATOR: { icon: 'nimbus-operator', weight: IconWeight.Regular },
  OPERATOR_CUSTOMER: { icon: 'nimbus-user-crown', weight: IconWeight.Light },
  OPERATOR_USER: { icon: 'nimbus-operator-user', weight: IconWeight.Regular },
  OUTLOOK: { icon: 'nimbus-outlook', weight: IconWeight.Regular },
  PAPERPLANE: { icon: 'nimbus-paperplane', weight: IconWeight.Regular },
  PARAMETERS: { icon: 'nimbus-parameters', weight: IconWeight.Light },
  PARK: { icon: 'nimbus-park', weight: IconWeight.Regular },
  PARK_ROUND: { icon: 'nimbus-park-round', weight: IconWeight.Regular },
  PAUSE: { icon: 'nimbus-pause', weight: IconWeight.Light },
  PEN_LIGHT: { icon: 'nimbus-pen', weight: IconWeight.Light },
  PERSONALHOME: { icon: 'nimbus-home', weight: IconWeight.Regular },
  PHONE: { icon: 'nimbus-phone', weight: IconWeight.Regular },
  PHONE_INBOUND: { icon: 'nimbus-phone-inbound', weight: IconWeight.Regular },
  PHONE_INBOUND_LIGHT: { icon: 'nimbus-phone-inbound', weight: IconWeight.Light },
  PHONE_LIGHT: { icon: 'nimbus-phone', weight: IconWeight.Light },
  PHONE_OUTBOUND: { icon: 'nimbus-phone-outbound', weight: IconWeight.Regular },
  PHONE_OUTBOUND_LIGHT: { icon: 'nimbus-phone-outbound', weight: IconWeight.Light },
  PHONE_SLASH: { icon: 'nimbus-phone-slash', weight: IconWeight.Regular },
  PIN: { icon: 'nimbus-pin', weight: IconWeight.Regular },
  PIN_LIGHT: { icon: 'nimbus-pin', weight: IconWeight.Light },
  PLAY: { icon: 'nimbus-play', weight: IconWeight.Regular },
  PRESENCE: { icon: 'nimbus-presence', weight: IconWeight.Regular },
  PREVIEW: { icon: 'nimbus-external-link', weight: IconWeight.Light },
  PRIORITY_TASK: { icon: 'nimbus-priority-task', weight: IconWeight.Regular },
  QUESTION: { icon: 'nimbus-question', weight: IconWeight.Regular },
  QUOTE: { icon: 'nimbus-quote', weight: IconWeight.Regular },
  RECURRENCE: { icon: 'nimbus-reset', weight: IconWeight.Regular },
  RECURRENCE_EXCEPTION: { icon: 'nimbus-reset-slash', weight: IconWeight.Regular },
  RELOAD: { icon: 'nimbus-reload', weight: IconWeight.Light },
  REMOVE_FORMAT: { icon: 'nimbus-remove-format', weight: IconWeight.Regular },
  REMOVE_VALUE: { icon: 'nimbus-minus', weight: IconWeight.Regular },
  REMOVE_VALUE_LIGHT: { icon: 'nimbus-minus', weight: IconWeight.Light },
  REPLY: { icon: 'nimbus-reply', weight: IconWeight.Regular },
  REPLY_ALL: { icon: 'nimbus-reply-all', weight: IconWeight.Regular },
  REPORTING: { icon: 'nimbus-reporting', weight: IconWeight.Regular },
  RESET: { icon: 'nimbus-reset', weight: IconWeight.Regular },
  RESUME: { icon: 'nimbus-play', weight: IconWeight.Light },
  RINGING: { icon: 'nimbus-ringing', weight: IconWeight.Regular },
  ROUTING: { icon: 'nimbus-routing', weight: IconWeight.Light },
  RUNBOOK: { icon: 'nimbus-runbook', weight: IconWeight.Light },
  SB_CHAT: { icon: 'nimbus-ac_connect-via-ms-teams', weight: IconWeight.Regular },
  SB_CONSULT: { icon: 'nimbus-swap', weight: IconWeight.Regular },
  SB_DIRECT_TRANSFER: { icon: 'nimbus-blind-transfer', weight: IconWeight.Regular },
  SB_SAVE_PARAMETERS: { icon: 'nimbus-save-parameters', weight: IconWeight.Regular },
  SB_TRANSFER: { icon: 'nimbus-transfer', weight: IconWeight.Regular },
  SEARCH: { icon: 'nimbus-search', weight: IconWeight.Regular },
  SEARCH_LIGHT: { icon: 'nimbus-search', weight: IconWeight.Light },
  SETTINGS: { icon: 'nimbus-settings', weight: IconWeight.Regular },
  SHARE: { icon: 'nimbus-share', weight: IconWeight.Regular },
  SKILL: { icon: 'nimbus-skill', weight: IconWeight.Regular },
  SKILL_LIGHT: { icon: 'nimbus-skill', weight: IconWeight.Light },
  SMILE_LIGHT: { icon: 'nimbus-smile', weight: IconWeight.Light },
  SORT_DOWN: { icon: 'nimbus-sort-down', weight: IconWeight.Light },
  SORT_UP: { icon: 'nimbus-sort-up', weight: IconWeight.Light },
  SPINNER: { icon: 'nimbus-spinner', weight: IconWeight.Regular },
  STAR: { icon: 'nimbus-star', weight: IconWeight.Regular },
  STAR_LIGHT: { icon: 'nimbus-star', weight: IconWeight.Light },
  STOP: { icon: 'nimbus-stop', weight: IconWeight.Light },
  STRIKE_THROUGH: { icon: 'nimbus-strike-through', weight: IconWeight.Regular },
  SUBSCRIPT: { icon: 'nimbus-subscript', weight: IconWeight.Regular },
  SUCCESS: { icon: 'nimbus-check-circle', weight: IconWeight.Regular },
  SUPERSCRIPT: { icon: 'nimbus-superscript', weight: IconWeight.Regular },
  SWAP: { icon: 'nimbus-swap', weight: IconWeight.Regular },
  SWAP_LIGHT: { icon: 'nimbus-swap', weight: IconWeight.Light },
  SWITCHBOARD: { icon: 'nimbus-attendant-console', weight: IconWeight.Regular },
  TABLE_HEADER: { icon: 'nimbus-input-customer', weight: IconWeight.Regular },
  TAG: { icon: 'nimbus-tag', weight: IconWeight.Regular },
  TAGS: { icon: 'nimbus-tags', weight: IconWeight.Regular },
  TAG_LIGHT: { icon: 'nimbus-tag', weight: IconWeight.Light },
  TARGET: { icon: 'nimbus-target', weight: IconWeight.Regular },
  TASK: { icon: 'nimbus-task', weight: IconWeight.Regular },
  TASKS: { icon: 'nimbus-check-list', weight: IconWeight.Regular },
  TASK_FLOW_VISUALIZER: { icon: 'nimbus-task-flow', weight: IconWeight.Regular },
  TEAMS: { icon: 'nimbus-my-teams', weight: IconWeight.Light },
  TENANT: { icon: 'nimbus-tenant', weight: IconWeight.Regular },
  THUMBS_UP: { icon: 'nimbus-thumbs-up', weight: IconWeight.Regular },
  TIMER: { icon: 'nimbus-timer', weight: IconWeight.Regular },
  TIMER_LIGHT: { icon: 'nimbus-timer', weight: IconWeight.Light },
  TIMES_CIRCLE: { icon: 'nimbus-times-circle', weight: IconWeight.Regular },
  TRANSCRIPTION: { icon: 'nimbus-transcription', weight: IconWeight.Regular },
  TRANSCRIPTION_LIGHT: { icon: 'nimbus-transcription', weight: IconWeight.Light },
  TRANSLATION_LIGHT: { icon: 'nimbus-translation', weight: IconWeight.Light },
  TRASH_LIGHT: { icon: 'nimbus-trash-alt', weight: IconWeight.Light },
  TRIGGER: { icon: 'nimbus-bolt', weight: IconWeight.Light },
  UNBAN: { icon: 'nimbus-unban', weight: IconWeight.Regular },
  UNDERLINE: { icon: 'nimbus-underline', weight: IconWeight.Regular },
  UNLOCK: { icon: 'nimbus-unlock', weight: IconWeight.Regular },
  UNLOCK_LIGHT: { icon: 'nimbus-unlock-alt', weight: IconWeight.Regular },
  UNPARK: { icon: 'nimbus-unpark', weight: IconWeight.Regular },
  UNPARK_ROUND: { icon: 'nimbus-unpark-round', weight: IconWeight.Regular },
  UPLOAD: { icon: 'nimbus-upload', weight: IconWeight.Regular },
  USER: { icon: 'nimbus-user', weight: IconWeight.Regular },
  USERS: { icon: 'nimbus-users', weight: IconWeight.Regular },
  USERS_LIGHT: { icon: 'nimbus-users', weight: IconWeight.Light },
  USERS_QUEUE: { icon: 'nimbus-users', weight: IconWeight.Regular },
  USER_EDIT: { icon: 'nimbus-user-edit', weight: IconWeight.Regular },
  USER_FRIENDS: { icon: 'nimbus-user-friends', weight: IconWeight.Regular },
  USER_FRIENDS_LIGHT: { icon: 'nimbus-user-friends', weight: IconWeight.Light },
  USER_LIGHT: { icon: 'nimbus-user', weight: IconWeight.Light },
  USER_SECRET: { icon: 'nimbus-user-secret', weight: IconWeight.Regular },
  USER_SETTINGS: { icon: 'nimbus-user-edit', weight: IconWeight.Regular },
  VIRTUAL_USER: { icon: 'nimbus-virtual-assistant', weight: IconWeight.Regular },
  VIRTUAL_USER_HANDOVER: { icon: 'nimbus-virtual-assistant', weight: IconWeight.Light },
  VIRTUAL_USER_LIGHT: { icon: 'nimbus-virtual-assistant', weight: IconWeight.Light },
  VOICEMAIL: { icon: 'nimbus-voicemail', weight: IconWeight.Regular },
  VOLUME_UP: { icon: 'nimbus-volume-up', weight: IconWeight.Regular },
  WAIT_PARAMETERS: { icon: 'nimbus-wait-for-parameters', weight: IconWeight.Regular },
  WARNING: { icon: 'nimbus-exclamation-triangle', weight: IconWeight.Regular },
  WARNING_LIGHT: { icon: 'nimbus-exclamation-triangle', weight: IconWeight.Light },
  WHISPER: { icon: 'nimbus-whisper', weight: IconWeight.Regular },
  WHISPER_LIGHT: { icon: 'nimbus-whisper', weight: IconWeight.Light },
  WORKFLOW: { icon: 'nimbus-workflow', weight: IconWeight.Regular },
  WRENCH: { icon: 'nimbus-wrench', weight: IconWeight.Regular },
};
